import React, { useState } from 'react';
import './App.css';

import Dashboard from './components/Dashboard';
import DeviceRegistration from './components/DeviceRegistration';
import NodeRegistration from './components/NodeRegistration';
import MeterDisplay from './components/MeterDisplay';

function App() {
  // Modern icon set (can be replaced with SVGs or a library)
  const NAV_ITEMS = [
    { key: 'meter', label: 'Live Data', icon: '📊' },
    { key: 'dashboard', label: 'Dashboard', icon: '📋' },
    { key: 'device', label: 'Register Devices', icon: '🖥️' },
    { key: 'node', label: 'Register Nodes', icon: '📡' },
  ];
  const [activeTab, setActiveTab] = useState('meter');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleDeviceRegistered = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleNodeRegistered = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="App modern-theme">
      <nav className="modern-navbar">
        <div className="navbar-logo">⚡ Wi-Sun E-Meter</div>
        <div className="navbar-items">
          {NAV_ITEMS.map(item => (
            <button
              key={item.key}
              className={`navbar-btn${activeTab === item.key ? ' active' : ''}`}
              onClick={() => setActiveTab(item.key)}
              aria-label={item.label}
            >
              <span className="navbar-icon">{item.icon}</span>
              <span className="navbar-label">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>

      <main className="modern-main">
        {activeTab === 'meter' && <MeterDisplay />}
        {activeTab === 'dashboard' && <Dashboard key={refreshKey} />}
        {activeTab === 'device' && (
          <DeviceRegistration onDeviceRegistered={handleDeviceRegistered} />
        )}
        {activeTab === 'node' && (
          <NodeRegistration onNodeRegistered={handleNodeRegistered} />
        )}
      </main>

      <footer className="modern-footer">
        <p>© 2025 Wisun E-Meter System | Powered by Aaensa Tech Pvt. Ltd.</p>
      </footer>
    </div>
  );
}

export default App;
